import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { isFeatureEnabled, hasTreatmentName } from '../utils'
import { Badge, ClockSmIcon, CriticalSmIcon } from '@paypalcorp/pp-react'
import serverData from '../utils/server-data'
import { dataPlatformConfig } from './data-privacy-data-platform'
import { pageSpec } from './fptiConstants'
const {
    userInfo = {},
    allowErasureRequest = false,
    unResolvedError = false,
  } = serverData,
  isMerchantUser = serverData.isMerchantUser,
  enabledForDownloadData = isFeatureEnabled('enabledForDownloadData'),
  enabledForCorrectData = isFeatureEnabled('enabledForCorrectData'),
  enabledForDeleteData = isFeatureEnabled('enabledForDeleteData'),
  enabledForFaceScan =
    isFeatureEnabled('enabledForFaceScan') && !isMerchantUser,
  enabledForManageDataSection =
    enabledForDownloadData ||
    enabledForCorrectData ||
    enabledForDeleteData ||
    enabledForFaceScan,
  isInFrame = serverData.isInFrame,
  { businessType = '', isSecondaryUser = false } = userInfo,
  subsectionComponent =
    serverData.selectedComponent === 'dw2' ? 'dw2' : 'default'

const allowedBusinessTypes = {
  INDIVIDUAL: true,
  PROPRIETORSHIP: true,
}

const isDataSectionCanbeShown = () => {
  let flag = false
  if (isMerchantUser) {
    if (!isSecondaryUser && allowedBusinessTypes[businessType.toUpperCase()]) {
      flag = true
    } else {
      return flag
    }
  } else {
    flag = true
  }
  return enabledForManageDataSection && flag
}

const pickElmoForDatasection = () => {
  let flag = false
  if (isMerchantUser) {
    flag =
      hasTreatmentName('Trmt_Merchant_Manage_Data_Section') ||
      hasTreatmentName('Trmt_Merchant_Manage_Data_Deletion')
  } else {
    flag =
      hasTreatmentName('Trmt_Manage_Data_Section') ||
      hasTreatmentName('Trmt_Manage_Data_Deletion') ||
      hasTreatmentName('Trmt_Manage_Data_Correction')
  }
  return flag
}

const getElementExpression = () => {
  let element = null
  if (allowErasureRequest) {
    element = <Message id="privacy.deleteData.description" />
  } else if (unResolvedError) {
    element = (
      <div className="subdwsection-flex-align">
        <CriticalSmIcon color="sysColorErrorMain" size="sm" />
        <Message id="dataErasure.preventrequset.error" />
      </div>
    )
  } else {
    element = (
      <div className="subdwsection-flex-align">
        <ClockSmIcon color="sysColorWarningMain" size="sm" />
        <Message id="dataErasure.preventrequset.inprogress" />
      </div>
    )
  }
  return element
}

const dataPlatformSections = [
  {
    sectionId: 'manageyourdata',
    sectionName: <Message id="privacy.data.sectionName" />,
    badge: {
      type: 'feature',
      text: <Message id="privacy.badge.new" />,
    },
    isEnabled: isDataSectionCanbeShown(),
    domid: 'manageyourdata',
    hasElmoTreatment: pickElmoForDatasection(),
    enabledCountries: [],
    subSections: [
      {
        subSectionId: 'download_data',
        title: <Message id="privacy.downloadData.title" />,
        desc: <Message id="privacy.downloadData.description" />,
        iconName: dataPlatformConfig.downloadData[subsectionComponent].iconName,
        domid: 'download_data',
        featureEnabled: enabledForDownloadData, //rcs service
        hasElmoTreatment: isMerchantUser
          ? hasTreatmentName('Trmt_Merchant_Manage_Data_Section')
          : hasTreatmentName('Trmt_Manage_Data_Section'),
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/dar?inframe=${isInFrame}`
            : '/myaccount/privacy/data/dar',
        fptiClickData:
          pageSpec.privacy_section_download_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
      {
        subSectionId: 'correct_data',
        title: <Message id="privacy.correctData.title" />,
        desc: <Message id="privacy.correctData.description" />,
        iconName: dataPlatformConfig.correctData[subsectionComponent].iconName,
        domid: 'correct_data',
        featureEnabled: enabledForCorrectData,
        hasElmoTreatment: isMerchantUser
          ? hasTreatmentName('Trmt_Merchant_Manage_Data_Section')
          : hasTreatmentName('Trmt_Manage_Data_Correction'),
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/dar/correction?inframe=${isInFrame}`
            : '/myaccount/privacy/data/dar/correction',
        fptiClickData:
          pageSpec.privacy_section_correct_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'manage_face_scan',
        title: <Message id="privacy.faceData.title" />,
        iconName:
          dataPlatformConfig.verificationData[subsectionComponent].iconName,
        domid: 'manage_face_scan',
        featureEnabled: enabledForFaceScan,
        navigateTo: '/myaccount/privacy/data/verify/facescan',
        hasElmoTreatment: true,
        fptiClickData: pageSpec.privacy_section_manage_face_scan_link(),
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'delete_data',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.deleteData.title'
                : 'privacy.deleteData.title'
            }
          />
        ),
        desc: getElementExpression(),
        iconName: dataPlatformConfig.deleteData[subsectionComponent].iconName,
        domid: 'delete_data',
        featureEnabled: enabledForDeleteData,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/deletion?inframe=${isInFrame}`
            : '/myaccount/privacy/data/deletion',
        hasElmoTreatment: isMerchantUser
          ? hasTreatmentName('Trmt_Merchant_Manage_Data_Deletion')
          : hasTreatmentName('Trmt_Manage_Data_Deletion'),
        fptiClickData:
          pageSpec.privacy_section_delete_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
    ],
  },
]

// this submodule has to retrieved from /api and will be served via serverData
dataPlatformSections[0].subSections[0].subModule = {
  subModuleId: 'data_request_history',
  title: <Message id="dar.history.header.title" />,
  desc: <Message id="dar.history.header.desc" />,
  badgeName: 'download',
  badgeFeature: 'feature',
  action: <Message id="privacy.merchant.action.view" />,
  domid: 'data_request_history',
  fptiClickData:
    pageSpec.privacy_section_data_request_history_link(isMerchantUser),
  modal: {
    name: 'dataRequestHistory',
  },
  navigateTo:
    isInFrame && isMerchantUser
      ? `/myaccount/privacy/data/dar/yourrequests?inframe=${isInFrame}`
      : '/myaccount/privacy/data/dar/yourrequests',
  enabled: () => {
    return Object.keys(serverData.darHistory).length > 0
  },
  badgeStatus: () => {
    const DARSTATUS = {
      OPEN: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.open.type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.open
              .className
          }
        >
          <Message id="dar.history.request.status.open" />
        </Badge>
      ),
      INPROGRESS: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.progress
              .type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.progress
              .className
          }
        >
          <Message id="dar.history.request.status.progress" />
        </Badge>
      ),

      CLOSED: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.download
              .type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.download
              .className
          }
        >
          <Message id="dar.history.request.status.download" />
        </Badge>
      ),
    }
    return DARSTATUS[
      Object.keys(serverData.darHistory).length > 0 &&
        serverData.darHistory[0].status
    ]
  },
}

export default dataPlatformSections
